import { Box } from "@mui/material"
import type { FC } from "react"
import { useState } from "react"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"
import { AerosTextField } from "@/components/UiKit/AerosTextField/AerosTextField"

interface QualityApprovalDenyDialogProps {
  isSubmitting: boolean
  onClose: () => void
  onConfirm: (denialReason: string) => void
}

export const QualityApprovalDenyDialog: FC<QualityApprovalDenyDialogProps> = ({ isSubmitting, onClose, onConfirm }) => {
  const [denialReason, setDenialReason] = useState("")

  const handleConfirm = () => {
    onConfirm(denialReason.trim())
  }

  const content = (
    <Box className='flex flex-col text-left'>
      <AerosTextField
        label='Denial Reason Comment'
        required
        value={denialReason}
        onChange={setDenialReason}
        placeholder='Enter reason for denial...'
        multiline
        minRows={4}
        disabled={isSubmitting}
        data-testid='quality-approval.deny-dialog.denial-reason-field'
      />
    </Box>
  )

  return (
    <ConfirmationDialog
      title='Are you sure you want to deny this test?'
      content={content}
      closeLabel='Go Back'
      confirmLabel='Deny Test'
      confirmDisabled={!denialReason.trim() || isSubmitting}
      testIdPrefix='quality-approval.deny-dialog'
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  )
}
